export default __webpack_public_path__ + "static/media/KO_Banner_Flower_Left2.347d74f9.png";